// extracted by mini-css-extract-plugin
export default {"content":"style_content__61Dj5","hidden":"style_hidden__u64FY","next":"style_next__qXMci"};